import { render, staticRenderFns } from "./CreateEditQuizStudent.vue?vue&type=template&id=0b081a27"
import script from "./CreateEditQuizStudent.vue?vue&type=script&lang=js"
export * from "./CreateEditQuizStudent.vue?vue&type=script&lang=js"
import style0 from "./CreateEditQuizStudent.vue?vue&type=style&index=0&id=0b081a27&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports